import React, { useEffect, useState } from 'react';
import './ScrollPrompt.css';

const ScrollPrompt = () => {
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setFadeOut(true);
        };

        window.addEventListener('wheel', handleScroll, { once: true });

        return () => {
            window.removeEventListener('wheel', handleScroll);
        };
    }, []);

    return (
        <div className={`scroll-prompt ${fadeOut ? 'fade-out' : ''}`}>
            <div className="mouse">
                <div className="scroll-wheel" />
            </div>
            <p>Scroll to navigate</p>
        </div>
    );
};

export default ScrollPrompt;
